import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import './StatusFilter.css';

const statuses = [
  'ACCEPT',
  'TO_BE_REVIEWED',
  'MAYBE',
  'ACCEPT_IN_PROCESS',
  'DENY',
];

export default function StatusFilter(props: {
  statusFilterChange: (_statuses: string[]) => void;
  statuses: string[];
}) {
  const [status, setStatus] = React.useState<string[]>(props.statuses);

  const handleChange = (event: SelectChangeEvent<typeof status>) => {
    const { target: { value } } = event;
    const _value = typeof value === 'string' ? value.split(',') : value;
    setStatus(_value);
    props.statusFilterChange(_value);
  };

  return (
    <div>
      <FormControl sx={{ width: 160 }}>
        <InputLabel id="label">Status</InputLabel>
        <Select
          labelId="label"
          multiple
          value={status}
          onChange={handleChange}
          input={<OutlinedInput label="Status"/>}
          renderValue={selected => selected.join(', ')}
          label="Status"
        >
          {statuses.map(name => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={status.indexOf(name) !== -1}/>
              <ListItemText primary={name}/>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
